import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import deleteAxpoSiteNameMapping from "../http/deleteAxpoSiteNameMapping";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const useDeleteAxpoSiteNameMapping = () => {
  const queryClient = useQueryClient();
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  return useMutation(
    async (siteId: string) =>
      deleteAxpoSiteNameMapping(
        await getAuthTokenBlocking(getToken, relogin),
        siteId
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["axpo-site-name-mappings"]);
      },
    }
  );
};

export default useDeleteAxpoSiteNameMapping;
